import { showArticle } from '@intercom/messenger-js-sdk'
import { Button } from '@populix/pop-ui'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'

import { Loading } from '@/components'
import { getQueryInfo } from '@/libs/apis/queries/use-suspense-get-query-info'
import { alert } from '@/libs/constants/images-library'
import { intercomAccountBlockedId } from '@/libs/constants/intercom-article'
import { useAppDispatch } from '@/libs/hooks/use-app-dispatch'
import { useAppSelector } from '@/libs/hooks/use-app-selector'
import { setShowNotificationRequest, setSuspend, toggleIntercom } from '@/libs/store/slice/ui-slice'

// TODO: refactor this into server component since no token required
export default function AccountSuspended() {
  const { push } = useRouter()
  const { email } = useAppSelector((state) => state.user)
  const { showNotificationRequest } = useAppSelector((state) => state.ui)
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const handleCheckSuspendStatus = async () => {
    if (!email) return setIsLoading(false)

    const status = await getQueryInfo(email)
    const isBanned = status?.data?.result?.isBanned

    setIsLoading(false)
    dispatch(setSuspend(!!isBanned))

    if (!isBanned) return push('/home')
  }

  const showIntercomArticle = () => {
    dispatch(toggleIntercom(true))
    return showArticle(intercomAccountBlockedId)
  }

  useEffect(() => {
    dispatch(setShowNotificationRequest(false))
  }, [dispatch, showNotificationRequest])

  useEffect(() => {
    handleCheckSuspendStatus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading) {
    return <Loading appear={isLoading} />
  }

  return (
    <div className='bg-pop-gray-8'>
      <main className='flex h-nav-screen items-center justify-center'>
        <div className='w-full md:flex-grow'>
          <form className='mx-auto flex max-w-md flex-col items-center gap-5 rounded-lg px-5'>
            <Image src={alert.src} alt={alert.alt} width={160} height={160} />
            <h1 className='text-center text-3xl font-bold'>Account Suspended</h1>
            <p className='text-center text-base font-normal text-pop-neutral-gray'>
              Your account has been restricted for violating Responova{' '}
              <Link href={'/articles/terms-and-condition'} className='text-pop-blue-400 underline'>
                Terms and Condition
              </Link>{' '}
              and{' '}
              <Link href={'/articles/privacy-policy'} className='text-pop-blue-400 underline'>
                Privacy Policy
              </Link>
              .
            </p>
            <Button
              type='button'
              variant='contained'
              color='primary'
              onClick={showIntercomArticle}
              aria-label='Learn More'
            >
              Learn More
            </Button>
          </form>
        </div>
      </main>
    </div>
  )
}
